import {ExternalDisplayConditionsApi} from './api/ExternalDisplayConditionsApi';
import {BaseValidatedClass} from './BaseValidatedClass';
import {DisplayCondition} from './modifications/ImmutableNode';

interface ExternalDisplayConditionsLibraryMap {
  getCategoryName(): string;
  openExternalDisplayConditionsDialog(
    _currentCondition: DisplayCondition,
    _successCallback: ExternalDisplayConditionSelectedCB,
    _cancelCallback: () => void,
  ): void;
  getIsContextActionEnabled(): boolean;
  getContextActionIndex(): number;
}

export type ExternalDisplayConditionSelectedCB = (condition: DisplayCondition) => void;

export interface ExternalDisplayConditionCategory {
  type: string;
  category: string; // Category name
}
export class ExternalDisplayConditionsLibrary extends BaseValidatedClass implements ExternalDisplayConditionsLibraryMap {
  public api!: ExternalDisplayConditionsApi;
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof ExternalDisplayConditionsLibraryMap)[] = ['getCategoryName', 'openExternalDisplayConditionsDialog'];

  constructor() {
    super(ExternalDisplayConditionsLibrary.REQUIRED_METHODS, ExternalDisplayConditionsLibrary);
  }

    /**
     * Retrieves the name of the category.
     *
     * @return {string} The name of the category.
     */
  public getCategoryName(): string {
    throw new Error('Method getCategoryName() must be implemented by the subclass');
  };

    /**
     * Opens a popup dialog for creating or updating a display condition.
     *
     * @param {DisplayCondition} _currentCondition - The currently selected display condition to edit.
     * @param {ExternalDisplayConditionSelectedCB} _successCallback - Callback executed with the updated or newly created condition upon success.
     * @param {() => void} _cancelCallback - Callback executed when the dialog is closed without making changes.
     */
  public openExternalDisplayConditionsDialog(
    _currentCondition: DisplayCondition,
    _successCallback: ExternalDisplayConditionSelectedCB,
    _cancelCallback: () => void,
  ): void {
    throw new Error('Method openExternalDisplayConditionsDialog() must be implemented by the subclass');
  }

    /**
     * Determines if the context action associated with this library is enabled.
     *
     * @returns {boolean} `true` if the context action is enabled, otherwise `false`.
     */
  public getIsContextActionEnabled(): boolean {
    throw new Error('Method getIsContextActionEnabled() must be implemented by the subclass');
  }

    /**
     * Retrieves the index of the context action associated with this library.
     * The index represents the position/order of the action in the UI.
     *
     * @returns {number} The index of the context action.
     */
  public getContextActionIndex(): number {
    throw new Error('Method getContextActionIndex() must be implemented by the subclass');
  }
}
